import { render } from "./barcodeComponent.vue?vue&type=template&id=5b7d35fe&scoped=true"
import script from "./barcodeComponent.vue?vue&type=script&lang=js"
export * from "./barcodeComponent.vue?vue&type=script&lang=js"

import "./barcodeComponent.vue?vue&type=style&index=0&id=5b7d35fe&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7d35fe"]])

export default __exports__